let html2Escape = (strText) => {
	if (typeof strText !== 'string') {
		return '';
	}
	return strText.replace(/[<>&"]/g, function(c) {
		return {
			'<': '&lt;',
			'>': '&gt;',
			'&': '&amp;',
			'"': '&quot;'
		} [c];
	});
}

export default {
	html2Escape
}